export default "<div #svgContainer\n  [class]=\"inputClass\"\n  [ngStyle]=\"{'color': iconColor, 'fill': iconColor}\">\n</div>\n";